export default "__VITE_ASSET__D4V1aP$M__"